module.exports = __webpack_public_path__ + "assets/img/pop-4.36a16de0.jpg";